import * as React from 'react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Container, Header, Content, Icon, Title } from './styled';

interface Props {
    title: React.ReactNode;
    message: React.ReactNode;
    noPadding?: boolean;
}

const ErrorMessage: React.StatelessComponent<Props> = ({ title, message }) => {
    return (
        // Ensures users can always tab from the error message
        <Container tabIndex={0} data-test-id="error-message">
            <Header>
                <Title>
                    <Icon>
                        <ErrorIcon label="error" secondaryColor={token('color.icon.inverse', colors.N0)} />
                    </Icon>

                    {title}
                </Title>
            </Header>
            <Content>{message}</Content>
        </Container>
    );
};

export default ErrorMessage;
